import { useCallback, useState } from "react";
import TownCouncilTableComponent from "./town-council-table.component";
import TableSort from "../../../../../shared/helpers/table-sort";
import capitalizeFirst from "../../../../../shared/helpers/upper-case";
import { useQuery } from "@tanstack/react-query";
import { getTownCouncils } from "../../../../../core/api/services/tc.service";

const TownCouncilComponent = () => {
  const [PageNumber, setPageNum] = useState<number>(1);
  const [tcSearchValue, setTcSearchValue] = useState("");
  const pageSize = 10;

  const [SortBy, setSortBy] = useState<any>(capitalizeFirst("towncouncilCode"));
  const [SortDirection, setSortDirection] = useState<any>("desc");

  const [columns, setColumns] = useState([
    {
      title: "Town Council Code",
      label: "towncouncilCode",
      isSorted: true,
    },
    {
      title: "Town Council Name",
      label: "name",
    },
    {
      title: "Town Council Address",
      label: "address",
      type: "scrollable-html",
      // maxHeight: "115px",
    },
  ]);

  const {
    data: townCouncils,
    isLoading: isLoadingTownCouncils,
    refetch,
  } = useQuery({
    queryKey: [
      "getTownCouncils",
      PageNumber,
      SortBy,
      SortDirection,
      tcSearchValue,
    ],
    queryFn: ({ signal }) =>
      getTownCouncils(
        PageNumber,
        pageSize,
        SortBy,
        SortDirection,
        tcSearchValue,
        signal
      ),
  });

  const onRefetchData = () => {
    if (townCouncils?.numberOfRecords <= pageSize + 1) {
      setPageNum(1);
    }
    refetch();
  };

  const handleChangePage = useCallback((page: number): void => {
    setPageNum(page);
  }, []);

  const handleSearch = useCallback((searchVal: string): void => {
    setPageNum(1);
    setTcSearchValue(searchVal);
  }, []);

  const handleChangeSort = useCallback(
    async (sortBy: string, sortDirection: any) => {
      if (!sortBy || !sortDirection) return;
      setSortBy(sortBy);
      setSortDirection(sortDirection);

      const copyColumns: any = await TableSort(columns, sortBy);
      setColumns(copyColumns);
    },
    []
  );

  return (
    <div>
      <TownCouncilTableComponent
        columns={columns}
        data={townCouncils?.data}
        totalNumberOfRecords={townCouncils?.numberOfRecords}
        pageSize={pageSize}
        current={PageNumber}
        onChangePage={handleChangePage}
        onRefetchData={onRefetchData}
        onChangeSort={handleChangeSort}
        isLoading={isLoadingTownCouncils}
        onSearch={handleSearch}
      />
    </div>
  );
};

export default TownCouncilComponent;
